function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary{fill:none;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  className: "highlights",
  d: "M85.05,100.37h0a30.54,30.54,0,0,1,30.54-30.54h18.79a30.54,30.54,0,0,1,30.54,30.54h0C164.92,117.24,85.05,117.24,85.05,100.37Z"
}), React.createElement("path", {
  className: "highlights",
  d: "M32.13,211.35h0a30.54,30.54,0,0,1,30.54-30.54H81.46A30.54,30.54,0,0,1,112,211.35h0C112,228.22,32.13,228.22,32.13,211.35Z"
}), React.createElement("path", {
  className: "highlights",
  d: "M144,214.54h0A30.54,30.54,0,0,1,174.54,184h18.79a30.54,30.54,0,0,1,30.54,30.54h0C223.87,231.41,144,231.41,144,214.54Z"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("circle", {
  className: "primary",
  cx: 124.99,
  cy: 49.12,
  r: 17.12
}), React.createElement("path", {
  className: "primary",
  d: "M85.05,100.37h0a30.54,30.54,0,0,1,30.54-30.54h18.79a30.54,30.54,0,0,1,30.54,30.54h0C164.92,117.24,85.05,117.24,85.05,100.37Z"
}), React.createElement("circle", {
  className: "primary",
  cx: 183.96,
  cy: 159.93,
  r: 17.16
}), React.createElement("path", {
  className: "primary",
  d: "M143.92,211.32h0a30.62,30.62,0,0,1,30.62-30.62h18.84A30.62,30.62,0,0,1,224,211.32h0C224,228.23,143.92,228.23,143.92,211.32Z"
}), React.createElement("circle", {
  className: "primary",
  cx: 72.04,
  cy: 159.93,
  r: 17.16
}), React.createElement("path", {
  className: "primary",
  d: "M32,211.32h0A30.62,30.62,0,0,1,62.62,180.7H81.46a30.62,30.62,0,0,1,30.62,30.62h0C112.08,228.23,32,228.23,32,211.32Z"
})));
var SvgMarketing = function SvgMarketing(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarketing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Marketing.0fa8a1bc.svg";
export { ForwardRef as ReactComponent };